module.exports = __webpack_public_path__ + "img/12_pretendstrong.d089cf57.png";